import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { PwaInstallService } from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pwa-install-banner.component.html',
    styleUrls: ['./pwa-install-banner.component.scss'],
})
export class PwaInstallBannerComponent {
  private readonly pwa = inject(PwaInstallService);

  vm$ = this.pwa.state$.pipe(
    map((state) => {
      const now = Date.now();
      const dismissed = now < (state.dismissedUntil || 0);
      const show = !state.isInstalled && !dismissed && (state.canInstall || state.isIos);
      return { ...state, show };
    })
  );

  dismiss() {
    this.pwa.dismiss(7);
  }

  async install() {
    await this.pwa.promptInstall();
  }
}

